import * as React from "react";
import { Search } from "lucide-react";
import { cn } from "../../lib/utils";

const SearchInput = React.forwardRef(function SearchInput(
  { className, inputClassName, ...props },
  ref,
) {
  return (
    <div className={cn("relative", className)}>
      <Search className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
      <input
        ref={ref}
        type="text"
        className={cn(
          "h-9 w-full rounded-lg border border-input bg-background pl-8 pr-3 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring",
          inputClassName,
        )}
        {...props}
      />
    </div>
  );
});

export { SearchInput };
